// extracted by mini-css-extract-plugin
module.exports = {"rating":"om-z","numberOfStars":"pm-z","count":"qm-z"};